export default {
	data() {
		return {
			specials: '!@#$%&*^()_+',
			length: 8,
		}
	},
	methods: {
		checkForLowercase(password) {
			return password.match(new RegExp(/[a-z]/))
		},
		checkForUppercase(password) {
			return password.match(new RegExp(/[A-Z]/))
		},

		checkForDigit(password) {
			return password.match(new RegExp(/[0-9]/))
		},

		checkForSpecial(password) {
			return password.match(new RegExp(/[!@#$%&*^()_+]/))
		},

		checkForWhitespaces(password) {
			return password.match(new RegExp(/\s/))
		},

		checkForLength(password) {
			return password.match(new RegExp(new RegExp(`.{${this.length},}`)))
		},

		passwordIsValid(password) {
			return (
				this.checkForLowercase(password) &&
				this.checkForUppercase(password) &&
				this.checkForDigit(password) &&
				this.checkForSpecial(password) &&
				!this.checkForWhitespaces(password) &&
				this.checkForLength(password)
			)
		},
	},
}
